import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/models/material-components.service';
import { MaterialModuleList } from 'src/app/material-module';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { CaptureLeadComponent } from 'src/app/Components/industry-engagements/capture-lead/capture-lead.component';


@NgModule({
  declarations: [
    CaptureLeadComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MaterialModuleList,
    HttpClientModule,
    RouterModule
  ],
  exports: [
    CaptureLeadComponent
  ]
})
export class CaptureLeadsModule { }
